@if (availableTags && availableTags.length && configuration.display) {
<div class="featured-badges-container">
    @for (tag of getTagsLimited( data ); track tag) {
    <ras-badge [configuration]="tag"></ras-badge>
    } @if (getTags(data).length > configuration.limitTags) {
    <ras-badge
        [configuration]="{
            key: 'more',
            label: getAdditionalTagLabel(data),
            styles: configuration.badgeStyles
        }"
    ></ras-badge>
    }
</div>
}
